<template>
  <v-list>
    <v-list-item v-for="(arma, index) in armasPersonal" :key="index">
      <v-list-item-content>
        <v-list-item-title>
          {{ arma.Arma.matricula }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ arma.Arma.CatClase.CatTipo.title }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    armasPersonal: {
      type: Array,
      required: true,
    },
  },
}
</script>
